import React from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';

import { makeGraph } from 'lib/commonLib';
import { FreqStatisticsTtimeGraphData } from 'lib/api/report';

import CurrentStatus from 'components/atoms/CurrentStatus';
import OutlinedButton from 'components/atoms/OutlinedButton';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const styles = (theme) => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      marginTop: '14px',
      marginRight: '18px',
    },
  },
  noMaxWidth: {
    maxWidth: 'none',
  },
  marginR0: {
    marginRight: '0 !important',
  },
  graphWrap: {
    width: '100%',
  },
  loading: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: '#fff',
    zIndex: '10',
    opacity: '0.4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

/**
 * 그레프 설정 (1)
 */
let graphList = new Array([]);
graphList['01'] = [
  {
    title: i18next.t('CTR'),
    data: {
      line: ['CLICK_RATE', 'WEB_CLICK_RATE', 'MOBILE_CLICK_RATE'],
    },
    yAxisData: {
      left: { CLICK_RATE: true, isPercent: true },
      right: {},
    },

    customizeData: {
      CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      MOBILE_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('세션ROAS'),
    data: {
      line: ['SESSION_ROAS', 'WEB_SESSION_ROAS', 'MOBILE_SESSION_ROAS'],
    },
    yAxisData: {
      left: { SESSION_ROAS: true, isPercent: true },
      right: {},
    },
    referenceLine: {
      SESSION_ROAS: {
        type: 'average',
        label: i18next.t('세션ROAS'),
      },
      WEB_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('Web 세션ROAS'),
      },
      MOBILE_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('Mobile 세션ROAS'),
      },
    },
    customizeData: {
      SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      MOBILE_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('총ROAS'),
    data: {
      line: ['ROAS', 'WEB_ROAS', 'MOBILE_ROAS'],
    },
    yAxisData: {
      left: { ROAS: true, isPercent: true },
      right: {},
    },
    referenceLine: {
      ROAS: {
        type: 'average',
        label: i18next.t('ROAS'),
      },
      WEB_ROAS: {
        type: 'average',
        label: i18next.t('WEB ROAS'),
      },
      MOBILE_ROAS: {
        type: 'average',
        label: i18next.t('MOBILE ROAS'),
      },
    },
    customizeData: {
      ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      MOBILE_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('전환율'),
    data: {
      line: ['CONV_RATE', 'WEB_CONV_RATE', 'MOBILE_CONV_RATE'],
    },
    yAxisData: {
      left: { CONV_RATE: true, isPercent: true },
      right: {},
    },
    referenceLine: {
      CONV_RATE: {
        type: 'average',
        label: i18next.t('CONV'),
      },
      WEB_CONV_RATE: {
        type: 'average',
        label: i18next.t('WEB CONV'),
      },
      MOBILE_CONV_RATE: {
        type: 'average',
        label: i18next.t('MOBILE CONV'),
      },
    },
    customizeData: {
      CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      WEB_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      MOBILE_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('eCPM'),
    data: {
      line: ['ECPM', 'WEB_ECPM', 'MOBILE_ECPM'],
    },
    yAxisData: {
      left: { ECPM: true },
      right: {},
    },
    referenceLine: {
      ECPM: {
        type: 'average',
        label: i18next.t('ECPM'),
      },
      WEB_ECPM: {
        type: 'average',
        label: i18next.t('WEB ECPM'),
      },
      MOBILE_ECPM: {
        type: 'average',
        label: i18next.t('MOBILE ECPM'),
      },
    },
    customizeData: {
      ECPM: {
        tooltipFormat: '0.00',
      },
      WEB_ECPM: {
        tooltipFormat: '0.00',
      },
      MOBILE_ECPM: {
        tooltipFormat: '0.00',
      },
    },
  },
  {
    title: i18next.t('노출'),
    data: {
      line: ['PAR_EPRS_CNT', 'WEB_PAR_EPRS_CNT', 'MOBILE_PAR_EPRS_CNT'],
    },
    yAxisData: {
      left: { PAR_EPRS_CNT: true },
      right: {},
    },
    referenceLine: {
      PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('노출'),
      },
      WEB_PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('WEB 노출'),
      },
      MOBILE_PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('MOBILE 노출'),
      },
    },
  },
  {
    title: i18next.t('소진'),
    data: {
      line: ['ADVRTS_AMT', 'WEB_ADVRTS_AMT', 'MOBILE_ADVRTS_AMT'],
    },
    yAxisData: {
      left: { ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('소진'),
      },
      WEB_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('WEB 소진'),
      },
      MOBILE_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('MOBILE 소진'),
      },
    },
  },
];
/**
 * 그레프 설정 (2)
 */
graphList['02'] = [
  {
    title: i18next.t('CTR'),
    data: {
      line: [
        'CW_CLICK_RATE',
        'SR_CLICK_RATE',
        'HU_CLICK_RATE',
        'RM_CLICK_RATE',
      ],
    },
    yAxisData: {
      left: { CONV_RATE: true, isPercent: true },
      right: {},
    },
    referenceLine: {
      CW_CLICK_RATE: {
        type: 'average',
        label: i18next.t('CW CTR'),
      },
      SR_CLICK_RATE: {
        type: 'average',
        label: i18next.t('SR CTR'),
      },
      HU_CLICK_RATE: {
        type: 'average',
        label: i18next.t('HU CTR'),
      },
      RM_CLICK_RATE: {
        type: 'average',
        label: i18next.t('RM CTR'),
      },
    },
    customizeData: {
      CW_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      SR_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      HU_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      RM_CLICK_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('세션ROAS'),
    data: {
      line: [
        'CW_SESSION_ROAS',
        'SR_SESSION_ROAS',
        'HU_SESSION_ROAS',
        'RM_SESSION_ROAS',
      ],
    },
    referenceLine: {
      CW_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('CW 세션ROAS'),
      },
      SR_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('SR 세션ROAS'),
      },
      HU_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('HU 세션ROAS'),
      },
      RM_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('RM 세션ROAS'),
      },
    },
    customizeData: {
      CW_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      SR_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      HU_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      RM_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('총ROAS'),
    data: {
      line: ['CW_ROAS', 'SR_ROAS', 'HU_ROAS', 'RM_ROAS'],
    },
    referenceLine: {
      CW_ROAS: {
        type: 'average',
        label: i18next.t('CW ROAS'),
      },
      SR_ROAS: {
        type: 'average',
        label: i18next.t('SR ROAS'),
      },
      HU_ROAS: {
        type: 'average',
        label: i18next.t('HU ROAS'),
      },
      RM_ROAS: {
        type: 'average',
        label: i18next.t('RM ROAS'),
      },
    },
    customizeData: {
      CW_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      SR_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      HU_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      RM_SESSION_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('전환율'),
    data: {
      line: ['CW_CONV_RATE', 'SR_CONV_RATE', 'HU_CONV_RATE', 'RM_CONV_RATE'],
    },
    referenceLine: {
      CW_CONV_RATE: {
        type: 'average',
        label: i18next.t('CW 전환율'),
      },
      SR_CONV_RATE: {
        type: 'average',
        label: i18next.t('SR 전환율'),
      },
      HU_CONV_RATE: {
        type: 'average',
        label: i18next.t('HU 전환율'),
      },
      RM_CONV_RATE: {
        type: 'average',
        label: i18next.t('RM 전환율'),
      },
    },
    customizeData: {
      CW_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      SR_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      HU_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      RM_CONV_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
  {
    title: i18next.t('eCPM'),
    data: {
      line: ['CW_ECPM', 'SR_ECPM', 'HU_ECPM', 'RM_ECPM'],
    },
    referenceLine: {
      CW_ECPM: {
        type: 'average',
        label: i18next.t('CW ECPM'),
      },
      SR_ECPM: {
        type: 'average',
        label: i18next.t('SR ECPM'),
      },
      HU_ECPM: {
        type: 'average',
        label: i18next.t('HU ECPM'),
      },
      RM_ECPM: {
        type: 'average',
        label: i18next.t('RM ECPM'),
      },
    },
  },
  {
    title: i18next.t('노출'),
    data: {
      line: [
        'CW_PAR_EPRS_CNT',
        'SR_PAR_EPRS_CNT',
        'HU_PAR_EPRS_CNT',
        'RM_PAR_EPRS_CNT',
      ],
    },
    referenceLine: {
      CW_PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('CW 노출'),
      },
      SR_PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('SR 노출'),
      },
      HU_PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('HU 노출'),
      },
      RM_PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('RM 노출'),
      },
    },
  },
  {
    title: i18next.t('소진'),
    data: {
      line: [
        'CW_ADVRTS_AMT',
        'SR_ADVRTS_AMT',
        'HU_ADVRTS_AMT',
        'RM_ADVRTS_AMT',
      ],
    },
    referenceLine: {
      CW_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('CW 소진'),
      },
      SR_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('SR 소진'),
      },
      HU_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('HU 소진'),
      },
      RM_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('RM 소진'),
      },
    },
  },
];

class StatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      graphComponent: {},
      selectedIdx: {},
      infoMessage: '',
      deviceLoading: false,
      deviceError: false,
      targetLoading: false,
      targetError: false,
    };
  }

  /**
   * API통해 데이터를 가져옴
   */
  getData = () => {
    const { params, t } = this.props;
    const { sDate, eDate } = params;
    const { switchDatas } = this.props;
    let primitiveData = [];

    // console.log(this.props.params);
    this.setState({
      ...this.state,
      deviceLoading: true,
      targetLoading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: sDate.substring(0, 6),
          endDate: eDate.substring(0, 6),
        }),
      }),
    });

    for (const tType of switchDatas) {
      FreqStatisticsTtimeGraphData({
        ...params,
        sDate: sDate.substring(0, 6),
        eDate: eDate.substring(0, 6),
        tType: tType,
      })
        .then((response) => {
          const { data } = response.data;
          primitiveData[tType] = data;
          if (tType === '01') {
            this.setState({
              ...this.state,
              primitiveData: primitiveData,
              deviceLoading: false,
              deviceError: false,
            });
          } else if (tType === '02') {
            this.setState({
              ...this.state,
              primitiveData: primitiveData,
              targetLoading: false,
              targetError: false,
            });
          }

          this.setGraphData(graphList[tType][0], tType, 0)();
        })
        .catch((error) => {
          if (tType === '01') {
            this.setState({
              ...this.state,
              deviceLoading: false,
              deviceError: true,
            });
          } else if (tType === '02') {
            this.setState({
              ...this.state,
              targetLoading: false,
              targetError: true,
            });
          }
        });
    }
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;
    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    return originalDate;
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {dayStr}
      </text>
    );
  };

  setGraphData =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      switchData,
      index
    ) =>
    (e) => {
      let { primitiveData } = this.state;

      if (Array.isArray(primitiveData) === true) {
        primitiveData = primitiveData[switchData];
      }

      if (typeof data !== 'undefined') {
        const {
          graphData,
          dataKeys,
          customizeData,
          keyLabel,
          stackId,
          referenceData,
        } = makeGraph({ data, customize, primitiveData, referenceLine });

        const result = (
          <MultiplexChart
            width="100%"
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
            key={switchData + '-' + index}
            referenceLine={referenceData}
          />
        );

        let { graphComponent, selectedIdx } = this.state;
        graphComponent[switchData] = result;
        selectedIdx[switchData] = index;

        this.setState({
          ...this.state,
          selectedIdx: selectedIdx,
          tType: switchData,
          selectedType: switchData,
          graphComponent: graphComponent,
        });
      }
    };

  render() {
    const { handleRefesh, setGraphData } = this;
    const { switchDatas, params } = this.props;
    let {
      infoMessage,
      graphComponent,
      selectedIdx,
      primitiveData,
      deviceLoading,
      deviceError,
      targetLoading,
      targetError,
    } = this.state;

    return (
      <>
        {switchDatas.map((type, i) => {
          let switchLabel = '';

          if (switchDatas[i] === '01') switchLabel = 'T-Time별 디바이스 비교 ';
          else if (switchDatas[i] === '02')
            switchLabel = 'T-Time별 타겟팅영역 비교';

          return (
            <React.Fragment key={type}>
              <SwitchingArea
                title={
                  <>
                    <InfoTitleArea
                      title={switchLabel}
                      tooltipTitle={infoMessage}
                      iconType="fainfoCircle"
                      iconColor="graph"
                    />
                  </>
                }
                handleRefesh={handleRefesh}
                hasExcel
                dataReqPromise={FreqStatisticsTtimeGraphData}
                params={params}
                type={switchDatas[i]}
              >
                {switchDatas[i] === '01' && (
                  <>
                    {deviceLoading || deviceError ? (
                      <CurrentStatus
                        type={
                          deviceLoading ? 'loading' : deviceError && 'error'
                        }
                      />
                    ) : (
                      <>
                        <ChartButtonWrap>
                          {graphList[type].map((item, index) => {
                            return (
                              <OutlinedButton
                                key={type + '-' + item.title}
                                onClick={setGraphData(item, type, index)}
                                selected={selectedIdx[type] === index}
                                disabled={!Boolean(primitiveData)}
                              >
                                {item.title}
                              </OutlinedButton>
                            );
                          })}
                        </ChartButtonWrap>
                        {graphComponent[type]}
                      </>
                    )}
                  </>
                )}
                {switchDatas[i] === '02' &&
                  (targetLoading || targetError ? (
                    <CurrentStatus
                      type={targetLoading ? 'loading' : targetError && 'error'}
                    />
                  ) : (
                    <>
                      <ChartButtonWrap>
                        {graphList[type].map((item, index) => {
                          return (
                            <OutlinedButton
                              key={type + '-' + item.title}
                              onClick={setGraphData(item, type, index)}
                              selected={selectedIdx[type] === index}
                              disabled={!Boolean(primitiveData)}
                            >
                              {item.title}
                            </OutlinedButton>
                          );
                        })}
                      </ChartButtonWrap>
                      {graphComponent[type]}
                    </>
                  ))}
              </SwitchingArea>
            </React.Fragment>
          );
        })}
      </>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withStyles(styles)(withTheme(StatisticsGraph)))
  )
);
